import { render, staticRenderFns } from "./ExpertAppointmentConfirmation.vue?vue&type=template&id=e067b4b8"
import script from "./ExpertAppointmentConfirmation.vue?vue&type=script&lang=ts"
export * from "./ExpertAppointmentConfirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports